import { createBrowserRouter, Navigate } from 'react-router-dom'
import { LanguageProvider } from '@/components/providers/LanguageProvider'
import { detectLocale } from '@/lib/i18n'
import Index from '@/pages/Index'
import SignIn from '@/pages/SignIn'
import AuthCallback from '@/pages/AuthCallback'
import NotFound from '@/pages/NotFound'
import Success from '@/pages/Success'
import ConfirmAccount from '@/pages/ConfirmAccount'
import Checkout from '@/pages/Checkout'
import Quiz from '@/pages/Quiz'


// Root component to handle language detection
function RootRedirect() {
  const browserLang = navigator.language
  const targetLang = detectLocale(browserLang)
  const basePath = '/product/clarymind-app'
  
  if (targetLang === 'en') {
    return <Navigate to={basePath} replace />
  }
  return <Navigate to={`/${targetLang}${basePath}`} replace />
}

// Component that redirects non-localized routes to their localized versions
function LocaleRedirectHandler() {
  const browserLang = navigator.language
  const targetLang = detectLocale(browserLang)

  if (targetLang === 'en') {
    return <LanguageProvider />
  }
  
  return <Navigate to={`/${targetLang}${window.location.pathname}${window.location.search}`} replace />
}

// Create router instance
export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootRedirect />
  },
  {
    path: '/*',
    element: <LocaleRedirectHandler />,
    children: [
      { path: 'product/clarymind-app', element: <Index /> },
      { path: 'quiz/clarymind-app', element: <Quiz /> },
      { path: 'sign-in', element: <SignIn /> },
      { path: 'auth/callback', element: <AuthCallback /> },
      { path: 'checkout', element: <Checkout /> },
      { path: 'success', element: <Success /> },
      { path: 'confirm-account', element: <ConfirmAccount /> }
    ]
  },
  {
    path: '/zh-TW/clarymind-app',
    element: <Navigate to="/zh-TW/product/clarymind-app" replace />
  },
  {
    path: '/:lang',
    element: <LanguageProvider />,
    children: [
      { index: true, element: <Navigate to="product/clarymind-app" replace /> },
      { path: 'product/clarymind-app', element: <Index /> },
      { path: 'quiz/clarymind-app', element: <Quiz /> },
      { path: 'sign-in', element: <SignIn /> },
      { path: 'auth/callback', element: <AuthCallback /> },
      { path: 'checkout', element: <Checkout /> },
      { path: 'success', element: <Success /> },
      { path: 'confirm-account', element: <ConfirmAccount /> },
      { path: '*', element: <NotFound /> }
    ]
  }
])